module.exports = __webpack_public_path__ + "img/CLIENT.b4ec32f8.svg";